/**
 * Headers contributed by the build rather than the caller. Production adds none,
 * so this is a no-op here; only mock-harness builds contribute anything.
 *
 * This file must stay on this path because it is the specifier the application
 * imports. A mock-harness build aliases that specifier to
 * `src/mock-harness/mock-harness-headers.ts`, so the body below never runs under
 * the harness — and the harness version never ships to production.
 */
export const getMockHarnessHeaders = (): Record<string, string> => ({});
